import { makeDefaultStylingContext } from '../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Ads: {},
  };
};
